import {BasicClient} from '@/utils/httpClient';

export default class Auth {
    client: BasicClient;
    constructor(){
        this.client = new BasicClient();
    }
    login(user: string, password: string){
        return this.client.exec('/v2/auth-mod/login', 'POST', {"user": user, "password": password});
    }
    loginCustomFile(fileName){
      return this.client.getFileJson(`${window.trcb.customLoginURL}/${fileName}_login.json`)
    }
    loginSSO(ssoToken: string) {
        return this.client.exec('/v2/auth-mod/login', 'POST', { sso: ssoToken })
    }
    logout() {
        return this.client.exec('/v2/auth-mod/logout', 'POST')
    }
    keepAlive() {
        return this.client.exec('/keepalive', 'GET')
    }
}
